import { getDoc, doc } from "firebase/firestore";
import { db } from "../firebase";
import { UserItemMaping, User, UserData } from "../model/Users";

const userQuery = {
  // 利用者詳細
  getUser: async (tenantId: string, userId: string) => {
    console.log("user getUser access");
    const userRef = await getDoc(
      doc(db, `/companies/${tenantId}/users`, userId)
    );
    const user = userRef.data();
    return UserItemMaping(user as User);
  },

  /**
   * ポイント情報を含めた利用者詳細を取得
   * @param tenantId テナントID
   * @param userId 利用者ID
   * @returns 利用者情報取得結果
   */
  getUserData: async (tenantId: string, userId: string): Promise<UserData> => {
    console.log("user getUserData access");
    const userRef = await getDoc(
      doc(db, `/companies/${tenantId}/users`, userId)
    );
    const user = userRef.data();
    return user as UserData;
  },
}

export default userQuery;